import { File } from "./schemas/file";
import { Point } from "./schemas/canvas-element";
import { createElementId, getUnixTimestampUTC } from "shared/util/utils";

export function placeFile(
  point: Point,
  type: "video" | "image",
  fileId: string | number | null,
  uploadStatus: "in-progress" | "completed",
  width?: number,
  height?: number,
  thumbnail?: string | null
) {
  return {
    id: createElementId(),
    file: {
      type: type,
      x: point.x,
      y: point.y,
      fileId: fileId,
      uploadStatus: uploadStatus,
      uploadProgess: 0,
      attachedConnectors: {},
      scaleX: 1,
      scaleY: 1,
      zIndexLastChangeTime: getUnixTimestampUTC(),
      width: width,
      height: height,
      thumbnail,
    } as File,
  };
}
